var external_file_provinces = [
  "Alaska (,)",
  "Alabama (AL)",
  "Arkansas (AR)",
  "Salta (ARA)",
  "Buenos Aires (ARB)",
  "Ciudad de Buenos Aires (ARC)",
  "San Luis (ARD)",
  "Entre RÃ­os (ARE)",
  "La Rioja (ARF)",
  "Santiago del Estero (ARG)",
  "Chaco (ARH)",
  "San Juan (ARJ)",
  "Catamarca (ARK)",
  "La Pampa (ARL)",
  "Mendoza (ARM)",
  "Misiones (ARN)",
  "Formosa (ARP)",
  "NeuquÃ©n (ARQ)",
  "Rio Negro (ARR)",
  "Santa Fe (ARS)",
  "TucumÃ¡n (ART)",
  "Chubut (ARU)",
  "Tierra del Fuego (ARV)",
  "Corrientes (ARW)",
  "CÃ³rdoba (ARX)",
  "Jujuy (ARY)",
  "Santa Cruz (ARZ)",
  "Arizona (AZ)",
  "Bocao (BOC)",
  "Acre (BR_AC)",
  "Alagoas (BR_AL)",
  "Amazonas (BR_AM)",
  "AmapÃ¡ (BR_AP)",
  "Bahia (BR_BA)",
  "CearÃ¡ (BR_CE)",
  "Distrito Federal (BR_DF)",
  "EspÃ­rito Santo (BR_ES)",
  "GoiÃ¡s (BR_GO)",
  "MaranhÃ£o (BR_MA)",
  "Minas Gerais (BR_MG)",
  "Mato Grosso do Sul (BR_MS)",
  "Mato Grosso (BR_MT)",
  "ParÃ¡ (BR_PA)",
  "ParaÃ­ba (BR_PB)",
  "Pernambuco (BR_PE)",
  "PiauÃ­ (BR_PI)",
  "ParanÃ¡ (BR_PR)",
  "Rio de Janeiro (BR_RJ)",
  "Rio Grande do Norte (BR_RN)",
  "RondÃ´nia (BR_RO)",
  "Roraima (BR_RR)",
  "Rio Grande do Sul (BR_RS)",
  "Santa Catarina (BR_SC)",
  "Sergipe (BR_SE)",
  "SÃ£o Paulo (BR_SP)",
  "Tocantins (BR_TO)",
  "Ciudad Autonoma de Buenos Aires (BUE01)",
  "California (CA)",
  "Chinandega (CHI)",
  "Chontales (CHO)",
  "Colorado (CO)",
  "Amazonas (CO01)",
  "Antioquia (CO02)",
  "Arauca (CO03)",
  "Atlantico (CO04)",
  "Caqueta (CO08)",
  "Cauca (CO09)",
  "Cesar (CO10)",
  "Choco (CO11)",
  "Cordoba (CO12)",
  "Guaviare (CO14)",
  "Guainia (CO15)",
  "Huila (CO16)",
  "La Guajira (CO17)",
  "Meta (CO19)",
  "Narino (CO20)",
  "Norte de Santander (CO21)",
  "Putumayo (CO22)",
  "Quindio (CO23)",
  "Risaralda (CO24)",
  "San Andres y Providencia (CO25)",
  "Santander (CO26)",
  "Sucre (CO27)",
  "Tolima (CO28)",
  "Valle del Cauca (CO29)",
  "Vaupes (CO30)",
  "Vichada (CO31)",
  "Casanare (CO32)",
  "Cundinamarca (CO33)",
  "Distrito Especial - BogotÃ¡ (CO34)",
  "Bolivar (CO35)",
  "Boyaca (CO36)",
  "Caldas (CO37)",
  "Magdalena (CO38)",
  "Connecticut (CT)",
  "Delaware (DE)",
  "EstelÃ (EST)",
  "Florida (FL)",
  "Georgia (GA)",
  "Granada (GRA)",
  "HawÃ¡i (HI)",
  "Iowa (IA)",
  "Idaho (ID)",
  "Illinois (IL)",
  "Indiana (IN)",
  "Jinotega (JIN)",
  "Kansas (KS)",
  "Kentucky (KY)",
  "Luisiana (LA)",
  "Leon (LEO)",
  "Massachusetts (MA)",
  "Masaya (MAS)",
  "Matagalpa (MAT)",
  "Maryland (MD)",
  "Madriz (MDR)",
  "Maine (ME)",
  "MÃ­chigan (MI)",
  "Minnesota (MN)",
  "Misuri (MO)",
  "Misisipi (MS)",
  "Montana (MT)",
  "Carolina del Norte (NC)",
  "Dakota del Norte (ND)",
  "Nebraska (NE)",
  "Nuevo Hampshire (NH)",
  "Nueva Jersey (NJ)",
  "Nuevo MÃ©xico (NM)",
  "Nueva Segovia (NSG)",
  "Nevada (NV)",
  "Nueva York (NY)",
  "Ohio (OH)",
  "Oklahoma (OK)",
  "OregÃ³n (OR)",
  "Pensilvania (PA)",
  "RAAN (RAA)",
  "RAAS (RAS)",
  "Rhode Island (RI)",
  "Rivas (RIV)",
  "Rio San Juan (RSJ)",
  "Carolina del Sur (SC)",
  "Dakota del Sur (SD)",
  "Tennessee (TN)",
  "Texas (TX)",
  "Utah (UT)",
  "Virginia (VA)",
  "Vermont (VT)",
  "Washington (WA)",
  "Wisconsin (WI)",
  "Virginia Occidental (WV)",
  "Wyoming (WY)"
];
